import React from 'react';
import Modal, { ModalHeader } from '@xo-union/tk-component-modals';
import { Button } from '@xo-union/tk-component-buttons';
import { compose } from '@xo-union/react-css-modules';
import styles from './index.scss';
import { ImageUpload, UploadInfo } from '../../../libs/gs-component-image-upload';

const modalClasses = compose({
  'close-button': styles.closeButton,
});

interface Props {
  openUploadModal: (uploadInfo: UploadInfo) => Promise<void>;
  setInfoModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  infoModalOpen: boolean;
}

const PhotoUploadSuggestion: React.FC<Props> = ({ setInfoModalOpen, infoModalOpen, openUploadModal }) => {
  return (
    <Modal classes={modalClasses} onClose={() => setInfoModalOpen(!infoModalOpen)}>
      <ModalHeader tabIndex={0}>Cover Photo Tips</ModalHeader>
      <div className={styles.uploadInformationList}>
        <li>Use a photo with a wide background.</li>
        <li>Don’t use close-ups or selfies.</li>
      </div>
      <div className={styles.uploadInformationButtons}>
        <div className={styles.closeButtonInModal}>
          <Button
            data-testid="photo-upload-suggestion-modal__close-button"
            size="md"
            onClick={() => setInfoModalOpen(!infoModalOpen)}
            color="secondary"
          >
            Cancel
          </Button>
        </div>
        <ImageUpload onUploadEnded={openUploadModal}>
          <div datatest-id="photo-upload-suggestion-modal__choose-button" className={styles.uploadButton}>
            <div>Choose Photo</div>
          </div>
        </ImageUpload>
      </div>
    </Modal>
  );
};

export default PhotoUploadSuggestion;
